import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { withRouter } from "react-router-dom";
import {
  IconButton,
  Paper,
  Tooltip,
  // , Grid
} from "@material-ui/core";
import {
  StyledAvatar,
  FinalWrapper,
  SuccessWrapper,
  OrderResultWrapper,
  SuccessSecondLineWrapper,
  ResultTitleTypography,
  IdTypography,
  StyledFileCopyIcon,
  SuccessTypography,
} from "./FuiStyles";
import { submitSuccess } from "./Constants/LongText";
import DoneIcon from "@material-ui/icons/Done";
import PropTypes from "prop-types";
import { AcceptButton } from "../common/CommonComponents/Buttons";

/**
 * Components which shows hints to users
 * @author Xiao Luo
 * @version 1.0
 * @see Used in component: All platforms and licenses, and appstepper
 */
const SubmitSuccess = ({ history, orderItemUId }) => {
  return (
    <Paper square elevation={0}>
      <FinalWrapper>
        <SuccessWrapper>
          <StyledAvatar>
            <DoneIcon />
          </StyledAvatar>
          <SuccessTypography>{submitSuccess}</SuccessTypography>
        </SuccessWrapper>
        <SuccessSecondLineWrapper>
          <OrderResultWrapper>
            <ResultTitleTypography>YOUR ORDER ID: </ResultTitleTypography>
            <IdTypography>{orderItemUId}</IdTypography>
            <CopyToClipboard text={orderItemUId}>
              <Tooltip title="Copy">
                <IconButton>
                  <StyledFileCopyIcon />
                </IconButton>
              </Tooltip>
            </CopyToClipboard>
          </OrderResultWrapper>
        </SuccessSecondLineWrapper>
        <div style={{ width: "10%", display: "block", margin: "0 auto" }}>
          <AcceptButton
            onClick={() => history.push("/fui/order")}
            label={"Okay"}
          />
        </div>
      </FinalWrapper>
    </Paper>
  );
};
SubmitSuccess.propTypes = {
  /**
   * History property of route library
   */
  history: PropTypes.object,
  /**
   * A UUID for each platform/app/license order
   */
  orderItemUId: PropTypes.string,
};
export default withRouter(SubmitSuccess);
